import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { noop } from 'lodash';
import socialNetworkNames from '../../../../constants/social-networks';
import { buildImageUrl } from '../utils';
import { buildUrl } from '../../../../../common/utils/url/build-url';
import { openPopup } from '../../../../../common/utils/open-popup';
import Tooltip from '../../../../ui-components/tooltip/tooltip';
import InlineIcon from '../../../../ui-components/inline-icon/inline-icon';
import parentStyles from '../styles.scss';
import PinterestIcon from '../../../../../icons/compiled/components/PinterestIcon';
class Pinterest extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "onClick", () => {
      const {
        descriptionText,
        canShareContent,
        content
      } = this.props;
      const {
        siteUrl
      } = this.props.instanceInfo;
      if (canShareContent) {
        const url = buildUrl('https://www.pinterest.com/pin/create/button/', {
          url: siteUrl,
          media: buildImageUrl(content.coverUrl),
          description: descriptionText.replace('{description}', content.description).replace('{title}', content.title)
        });
        openPopup(url);
      }
      this.props.onShare(socialNetworkNames.PINTEREST);
    });
  }
  render() {
    const {
      className,
      dataHook,
      ariaLabel,
      tooltip
    } = this.props;
    return /*#__PURE__*/React.createElement(Tooltip, {
      content: tooltip
    }, /*#__PURE__*/React.createElement("button", {
      onClick: this.onClick,
      "data-hook": dataHook,
      className: className,
      "aria-label": ariaLabel
    }, /*#__PURE__*/React.createElement(InlineIcon, {
      icon: /*#__PURE__*/React.createElement(PinterestIcon, null),
      className: parentStyles.icon
    })));
  }
}
_defineProperty(Pinterest, "defaultProps", {
  onShare: noop
});
export default Pinterest;
//# sourceMappingURL=pinterest.js.map